import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { Injector, } from '@angular/core';
import { MapperService } from '@services/mapper.service';
import { BaseLicenseService } from 'main/app-state/current-user/license/base-license.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var HostLicenseService = /** @class */ (function (_super) {
    tslib_1.__extends(HostLicenseService, _super);
    function HostLicenseService(http, _injector) {
        var _this = _super.call(this, http, MapperService.hostLicenseMap, _injector) || this;
        _this._injector = _injector;
        _this._endpoint = '/odata/HostLicenses';
        return _this;
    }
    HostLicenseService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HostLicenseService_Factory() { return new HostLicenseService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i0.INJECTOR)); }, token: HostLicenseService, providedIn: "root" });
    return HostLicenseService;
}(BaseLicenseService));
export { HostLicenseService };
